
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M14 17V21H22V17M18 19V14M18 14L16 16M18 14L20 16"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M21.97 12.7809C21.9899 12.5232 22 12.2628 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.2628 22 12.5232 21.9899 12.7809 21.97C11.6771 20.805 11 19.2316 11 17.5C11 15.9753 11.525 14.5732 12.404 13.4647L12 13.0607L9.03033 16.0303L7.96967 14.9697L10.9393 12L7.96967 9.03033L9.03033 7.96967L12 10.9393L14.9697 7.96967L16.0303 9.03033L13.0607 12L13.4647 12.404C14.5732 11.525 15.9753 11 17.5 11C19.2316 11 20.805 11.6771 21.97 12.7809Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowCancelExportFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
